import axios from 'axios'

export async function base64FromUrl (url) {
  const res = await axios({
    method: 'get',
    url,
    responseType: 'arraybuffer'
  })
  return Buffer.from(res.data, 'binary').toString('base64')
}
